import axios from 'axios'
import { BLOQUEAR_POLTRONA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function bloquearPoltrona (parametros) {
  const url = `${URL}/poltronas/bloquear`;
  return dispatch => axios.post(url,parametros , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BLOQUEAR_POLTRONA,
        payload: response
      })
  );
}
